(ns minorodata.connections.sources.twilio
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "twilio"
   :enabled      true
   :name         "Twilio"
   :description  "Unite communications and strengthen customer relationships across your business"
   :image-source "twilio.svg"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description account-sid auth-token]} data]
        {:source-type "twilio"
         :name        name
         :description description

         :source
         {:credentials         {:type                   "token"
                                :account-sid            account-sid
                                :auth-token             auth-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge
         (select-keys credentials [:account-sid :auth-token])
         {:name              name
          :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :twilio-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Account SID or API Key SID"
              :required   true
              :name       :account-sid
              :value      ""}
             {:block-type :input
              :label      "Auth Token or API Key Secret"
              :required   true
              :name       :auth-token
              :type       :password
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :destination-table destination-table
                    :action            action}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :hgem-client-id :action :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :twilio-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Calls"    :value "calls"}
                           {:name "Messages" :value "messages"}]
              :required   true
              :value      "calls"}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
